import type { PokemonV2 } from '../../types/pokemon';
import { NOT_LAST_EVOLVE_POKEMON_IDS } from './not-last-evolve-id-list';
import { NOT_LAST_EVOLVE_POKEMON_NAMES } from './not-last-evolve-name-list';

// 最終進化前かどうかをID/名前で判定する
export const isNotLastEvolvePokemon = (p: PokemonV2 | null | undefined): boolean => {
  const name = p?.name_ja;
  if (name && NOT_LAST_EVOLVE_POKEMON_NAMES.has(name)) {
    return true;
  }
  const speciesId = p?.species_id ?? p?.id;
  if (speciesId == null || !NOT_LAST_EVOLVE_POKEMON_IDS.has(speciesId)) {
    return false;
  }
  // フォルム差分はIDで補正する（名称がリストに無い場合の補完）
  return Boolean(!name || name.includes('('));
};

// 最終進化かどうかを判定する
export const isLastEvolvePokemon = (p: PokemonV2 | null | undefined): boolean => {
  if (!p) {
    return false;
  }
  return !isNotLastEvolvePokemon(p);
};
